import { useEffect } from "react";
import Clarity from "@microsoft/clarity";
import { clarityProjectIds } from "@/lib/constants/clarity-constants";

declare global {
  interface Window {
    __clarity_started?: boolean;
  }
}

export function useClarity() {
  useEffect(() => {
    const hostname = window.location.hostname;
    const clarityId = clarityProjectIds[hostname];

    if (!clarityId) {
      console.warn(`[Clarity] No project ID found for host: ${hostname}`);
      return;
    }

    if (!window.__clarity_started) {
      Clarity.init(clarityId);
      window.__clarity_started = true;
      console.log(`[Clarity] Started for ${hostname}`);
    }
  }, []);
}
